<div class="portal--header">
    <a (click)="navigateBack()" style="cursor:pointer" class="focus-element text-link"><span class="focus--content" tabindex="-1" title="Back">< Back to previous page</span></a>
    <h1 class="heading">
        {{consumer.consumerName}} <span class="ic-wrapper lg" title="vulnerable" *ngIf="consumer.vulnerable"><svg class="ic"><use xlink:href="#ic-vulnerable" href="#ic-vulnerable"></use></svg></span>
        <ul class="subheading list">
            <li class="list--item">{{consumer.consumerAddress}}</li>
            <li class="list--item">{{consumer.consumerType}} consumer</li>
            <li class="list--item">Account from {{consumer.consumerFromDate | date:'dd/MM/yyyy'}}</li>
            <li class="list--item" *ngIf="consumer.consumerTodate">Account to {{consumer.consumerTodate | date:'dd/MM/yyyy'}}</li>
        </ul>
    </h1>
    <!--<h1 class="heading" *ngIf="consumerHasPayg">
        <div class="portal--header--status-wrapper">
            This PAYG device is: <div class="portal--header--status">
                <span class="h-bold h-uppercase" [ngClass]="{'text-color__success': deviceStatus == 'CONNECTED', 'text-color__warning': deviceStatus == 'CONNECTING', 'text-color__error': deviceStatus == 'UNAVAILABLE' }">{{deviceStatus}}</span>
                <button class="info-btn info-btn__white focus-element" (click)="connectionStatusInfo()">
                    <span class="focus--content" tabindex="-1">
                        <span>i</span>
                    </span>
                </button>
                <button *ngIf="deviceStatus === 'UNAVAILABLE'" class="focus-element" (click)="onDeviceStatusRefresh()">
                    <span class="focus--content" tabindex="-1">
                        <svg class="m-ic" [ngClass]="{'spin' : isProcessing}"><use xlink:href="#ic-refresh-white" href="#ic-refresh-white"></use></svg>
                    </span>
                </button>
            </div>
        </div>
    </h1>-->
    <div class="header--dropdown text-light">
        <button class="header-dropdown--main focus-element open" [ngClass]="{'open': !issuesTabOpen }" (click)="toggleIssuesTab()" collapsible [collapsibleSection]="collapsibleSection">
            <span class="focus--content" tabindex="-1">
                <h3 class="dropdown--heading">Issues</h3>
                <p class="dropdown--description">This consumer has {{consumerIssues.length}} issue(s)</p>
                <svg class="ic-arrow"><use xlink:href="#ic-arrow-white" href="#ic-arrow-white"></use></svg>
            </span>
        </button>
        <ul class="header--dropdown-list" #collapsibleSection>
            <li class="list--item" *ngFor="let consumerIssue of consumerIssues">
                <span class="message">{{consumerIssue.issueText}}</span>
                <div class="ic-beware-wrapper"><span class="ic-beware">!</span></div>
            </li>
        </ul>
    </div>
</div>
<div class="portal--main">
    <div class="module-wrapper">
        <div class="module drop-shadow bottom" *ngIf="consumerModeTimeline && consumerModeTimeline.length > 1">
            <div class="dashboard--module-header">
                <h2 class="subheading-sm">Consumer mode timeline</h2>
            </div>
            <div class="chart timeline-chart">
                <ul class="key">
                    <li class="key--item" *ngFor="let timelineItem of consumerTimeLine">
                        <div class="color" [ngStyle]="{'border-color': timelineItem.colour, 'background-color': timelineItem.colour}"></div>
                        <span class="label">{{timelineItem.consumerType}} consumer</span>
                    </li>
                </ul>
                <div class="timeline">
                    <div class="section" *ngFor="let timelineItem of consumerTimeLine;let i = index" [ngStyle]="{'border-color': timelineItem.colour, 'background-color': timelineItem.colour, 'width': timelineItem.precentage}">
                        <span class="date" *ngIf="i > 0">{{timelineItem.recordFromDate | date:'dd/MM/yyyy'}}</span>
                        <span class="date">{{timelineItem.recordToDate | date:'dd/MM/yyyy'}}</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="c-nav--secondary-wrapper">
            <div class="c-nav--secondary btn-group">
                <span *ngFor="let navItem of navigationList">
                    <a *ngIf="navItem.isShown"
                       class="std-btn focus-element subnav-btn" [ngClass]="{'active': selectedNavItem == navItem.key}" (click)="toggleConsumerDetail(navItem.key)">
                        <span class="focus--content" tabindex="-1">
                            {{navItem.label}}
                        </span>
                    </a>
                </span>
            </div>
            <hr *ngIf="consumerModeTimeline.length > 1">
            <div class="flex-grid end stack-sm">
                <div class="flex-grid--item organise-select c-nav--secondary__filter">
                    <label for="">View:</label>
                    <select name="timePeriod" id="" class="select__standalone" (change)="update($event.target.value)" #timePeriod>
                        <option value="1">Last 30 Days</option>
                        <option value="2">Last 60 Days</option>
                        <option value="3">Last 90 Days</option>
                    </select>
                </div>
            </div>
        </div>
    </div>
    <consumer-detail-account *ngIf="selectedNavItem == 'account' && (consumerHasPayg || consumerHasBilling)" [clientId]="clientId" [consumerId]="consumerId" [consumerIssues]="consumerIssues" [consumer]="consumer"></consumer-detail-account>
    <consumer-detail-tarrif-consumption *ngIf="selectedNavItem == 'tarrifAndConsumption' && (consumerHasPayg || consumerHasBilling)" [clientId]="clientId" [consumerId]="consumerId" [consumerIssues]="consumerIssues" [consumer]="consumer"></consumer-detail-tarrif-consumption>
    <!--<consumer-detail-device *ngIf="selectedNavItem == 'device' && consumerHasPayg && isPaygUpdate" [clientId]="clientId" [consumerId]="consumerId"></consumer-detail-device>-->
</div>
